import * as State from 'components/desktop/MenuPlan/Search/PublishingModal/State';
import { useHandler } from 'hooks/useHandler';

export default function useState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			toggleString: rf.createReducer(State.toggleString),
			sendToApi: rf.createReducerAsync(State.sendToApi),
		},
	};
}

export type RecipeErpViewHandlers = ReturnType<typeof useState>['handlers'];
